import styled from "styled-components";

import {
  DefaultParagraphLargeFactory,
  DefaultParagraphMediumFactory,
  DefaultTitleLargeFactory,
  DefaultTitleSmallFactory,
} from "../../Habitacional/core/Typograph/Typograph.Style";

const flexDirection = {
  display: "flex",
  flexDirection: "column",
};

export const PQOResultsSectionContainer = styled.section(({ theme }) => ({
  paddingTop: "40px",
  paddingBottom: "40px",
  marginBottom: "0 !important",

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
  },
}));

export const PQOResultsSectionContent = styled.div(({ theme }) => ({
  ...flexDirection,
  gap: "24px",

  span: {
    ...DefaultParagraphMediumFactory({ theme }),
  },
}));

export const PQOResultsSectionHeader = styled.div(() => ({
  ...flexDirection,
  gap: "24px",
}));

export const PQOResultsSectionTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
}));

export const PQOResultsSectionDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),
}));

export const PQOResultsSectionList = styled.div(() => ({
  ...flexDirection,
  gap: "32px",
}));

export const PQOResultsSectionFooter = styled.div(() => ({
  display: "flex",
  justifyContent: "flex-end",
}));

export const PQOResultsSectionItem = styled.div(({ theme }) => ({
  ...flexDirection,
  gap: "12px",

  span: {
    ...DefaultParagraphMediumFactory({ theme }),
    wordBreak: "break-all",
  },
}));

export const PQOResultsSectionItemTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleSmallFactory({ theme }),
  fontWeight: "700",
}));

export const PQOResultsSectionItemContent = styled.div(({ theme }) => ({
  ...DefaultParagraphMediumFactory({ theme }),
}));

export const PQOResultsSectionItemDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),
}));
